import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const UploadIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 48 48"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M37 30V37H11V30" stroke="currentColor" strokeWidth="2" />
            <path d="M24 12V32" stroke="currentColor" strokeWidth="2" />
            <path
                d="M14 18L22.971 12.6174C23.6044 12.2374 24.3956 12.2374 25.029 12.6174L34 18"
                stroke="currentColor"
                strokeWidth="2"
            />
        </svg>
    </IconWrapper>
)
